export default {
  no_storefront_found: {
    title: 'Ingen butiksfacade fundet',
    description: 'Opret en butiksfacade.',
  },
};
